<div class="main-container">
    <app-list-header
        [title]="title"
        icon="check_circle"
        [searchPlaceholder]="'status.search' | translate"
        [searchTerm]="searchTerm | async"
        (searchTermChange)="searchTerm.next($event); searchStatus()"
        (clearSearch)="clearFilter()"
        (addNewItem)="createStatus()"
    ></app-list-header>

    <div class="table-container">
        <table class="list-table">
            <tbody>
                <tr
                    *ngFor="let status of filteredStatus | async"
                    (click)="select(status)"
                    [class.selected]="status === selectedStatus"
                >
                    <td class="color-cell">
                        <span class="color-dot" [style.background-color]="status.color"></span>
                    </td>
                    <td class="name-cell">{{ status.name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
